import React, { useState, useEffect, useRef } from 'react';
import { getStyle } from '@coreui/utils';
import { CChart } from '@coreui/react-chartjs';
import { BASE_URL } from "../../App";
import axios from 'axios';

const ChartBarExample = () => {
  const chartRef = useRef(null);

  const USER_ID = localStorage.getItem("USER_ID");

  const [chartData, setChartData] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const fetchChartData = async (monthName) => {
    setLoading(true);
    try {
      const response = await axios.post(BASE_URL + '/customer_enquery_piechart', {
        userid: USER_ID,
        selectmonth: monthName,
      });

      const data = response.data.data;

      if (data && data.length > 0) {
        const newChartData = {
          labels: data.map(item => item.status),
          datasets: [
            {
              label: 'Service Calls',
              backgroundColor: generateRandomColors(data.length),
              data: data.map(item => parseInt(item.total_calls)),
            },
          ],
        };

        setChartData(newChartData);
        setNoData(false);
      } else {
        setNoData(true);
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  const generateRandomColors = (numColors) => {
    const colors = [];
    for (let i = 0; i < numColors; i++) {
      const randomColor = `#${Math.floor(Math.random()*16777215).toString(16)}`;
      colors.push(randomColor);
    }
    return colors;
  };

  useEffect(() => {
    fetchChartData(monthNames[selectedMonth]);
  }, [selectedMonth]);

  const handleMonthChange = (event) => {
    setSelectedMonth(Number(event.target.value) - 1);
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: getStyle('--cui-body-color'),
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(2);
            return `${label}: ${value} calls (${percentage}%)`;
          }
        }
      },
    },
    scales: {
      x: {
        ticks: { color: getStyle('--cui-body-color') },
        grid: { display: false }
      },
      y: {
        beginAtZero: true,
        ticks: { color: getStyle('--cui-body-color') },
        grid: { color: '#e4e5e7' }
      }
    }
  };

  return (
    <div className='row'>
      <div className='col-md-8'>
        <h3>Month Service Calls Count</h3>
        <div className="chart-container" style={{ position: 'relative' }}>
          <div className="month-selector" style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 10 }}>
            <select value={selectedMonth + 1} onChange={handleMonthChange}>
              {monthNames.map((name, index) => (
                <option key={index} value={index + 1}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          {loading && <div>Loading...</div>}
          {noData && !loading && <div>No data available for {monthNames[selectedMonth]}</div>}
          {!loading && !noData && (
			<div style={{ width: '100%', height: '600px', padding: '20px', }} >
				<CChart type="bar" data={chartData} options={options} ref={chartRef} />
			</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChartBarExample;
